import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextInputComponent,
      multi: true
    }
  ]
})
export class TextInputComponent extends BaseControlComponent {
  @Input() public inputLabel?: string;
  @Input() public autocomplete?: string;
  @Input() public maxLength?: number;
  @Input() public pattern: string;
  @Input() public isReadonly: boolean;
  @Input() public digitsOnly: boolean;
  @Input() public disablePeriod: boolean;
  @Input() public type: 'text' | 'tel' | 'password' | 'email' = 'text';
  @Input() public forceRequired: boolean;
  @Input() public isTooltipLast = false;
  @Input() public canShowPassword = false;

  @ViewChild('htmlInput') htmlInput: ElementRef;

  public toggleShowPassword(): void {
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  public ensureTrimmedValue(): any {
    this.value = this.value !== null && typeof this.value === 'string' ? this.value.trim() : this.value;
  }
}
